import { useEffect } from "react";
import { supabase } from "./lib/supabase";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import Index from "./pages/Index";
import Login from "./pages/Login";
import Register from "./pages/Register";
import NewProject from "./pages/NewProject";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import BuyCredits from "./pages/BuyCredits";
import SuccessPage from "./pages/SuccessPage";
import CancelPage from "./pages/CancelPage";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";
import OchranaOsobnichUdaju from "./pages/OchranaOsobnichUdaju";
import ObchodniPodminky from "./pages/ObchodniPodminky";
import Kontakt from "./pages/Kontakt";
import Examples from "./pages/Examples";
import AccountPage from './pages/Account';
import ForgotPasswordPage from './pages/ForgotPassword';
import ResetPasswordPage from './pages/ResetPassword';
import Cenik from './pages/Cenik';

const queryClient = new QueryClient();

const App = () => {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <AuthProvider>
            <Toaster />
            <Sonner />
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              {/* Protected Routes */}
              <Route
                path="/new-project"
                element={
                  <ProtectedRoute>
                    <NewProject />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/projects"
                element={
                  <ProtectedRoute>
                    <Projects />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/projects/:id"
                element={
                  <ProtectedRoute>
                    <ProjectDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/buy-credits"
                element={
                  <ProtectedRoute>
                    <BuyCredits />
                  </ProtectedRoute>
                }
              />
              <Route path="/success" element={<SuccessPage />} />
              <Route path="/cancel" element={<CancelPage />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute requireAdmin>
                    <Admin />
                  </ProtectedRoute>
                }
              />
              <Route path="/ochrana-osobnich-udaju" element={<OchranaOsobnichUdaju />} />
              <Route path="/obchodni-podminky" element={<ObchodniPodminky />} />
              <Route path="/kontakt" element={<Kontakt />} />
              <Route path="/examples" element={<Examples />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/cenik" element={<Cenik />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AuthProvider>
        </TooltipProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
};

export default App; 